import {activityPlaces} from '@mep/pae-commons';
import {Tag} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {ACTIVITY_PLACE_TYPES_APPEARANCE} from '@/modules/activityPlace/contants/activityPlace.status';

const {ACTIVITY_PLACE_TYPES_ENUM} = activityPlaces;

const ActivityPlaceTypes = ({status, full, className, icon, translationKey, ...props}) => {
  const {t} = useTranslation('activityPlace');
  
  if (!status) return null;
  
  if (!ACTIVITY_PLACE_TYPES_APPEARANCE[status]) return (
    <Tag key={status} className={classNames({'w-full': full}, {'mx-auto': !full}, className, 'w-16 text-center')}>
      -
    </Tag>);
  
  return (<Tag
    color={ACTIVITY_PLACE_TYPES_APPEARANCE[status].color} key={status}
    className={classNames('table-tag-item', {'w-full': full}, {'mx-auto': !full}, 'max-w-44 flex justify-center', className)} {...props}>
    <div className={'flex items-center truncate'} title={t(`${translationKey}.${status}`)}>
      {icon}
      <span className={'flex-grow uppercase truncate'}>{t(`${translationKey}.${status}`)}</span>
    </div>
  </Tag>);
};

ActivityPlaceTypes.propTypes = {
  className: PropTypes.string,
  translationKey: PropTypes.string,
  full: PropTypes.bool,
  status: PropTypes.oneOf(ACTIVITY_PLACE_TYPES_ENUM),
  icon: PropTypes.any,
};

ActivityPlaceTypes.defaultProps = {
  translationKey: 'types'
};

export default memo(ActivityPlaceTypes);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Status component in a table cell
 * @param {String} status this is the value of the dataIndex of the table (we will ignored in this case)
 * */
export const renderActivityPlaceType = (status) => {
  return (<ActivityPlaceTypes status={status}/>);
};
